import type EnType from '../en-US/http';

export default {
  'httpRequestResult.response': 'Respuesta',
  'httpRequestResult.noResponseDesc': 'Haz clic en Enviar para obtener una respuesta',
} satisfies typeof EnType;
